// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EmailSendDefaultResponse {
    static getAttributeTypeMap() {
        return EmailSendDefaultResponse.attributeTypeMap;
    }
}
EmailSendDefaultResponse.discriminator = undefined;
EmailSendDefaultResponse.additionalProperties = false;
EmailSendDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "boolean"
    },
];
//# sourceMappingURL=emailSendDefaultResponse.js.map